import { createReducer, on } from '@ngrx/store';
import * as AskActions from './community-ask.action';

export interface AskState {
  ask: any[];
  loading: boolean;
  error: any;
}

export const initialState: AskState = {
  ask: [],
  loading: false,
  error: null,
};

export const communityAskReducer = createReducer(
  initialState,
  on(AskActions.loadCommunityAsk, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AskActions.loadCommunityAskSuccess, (state, { ask }) => ({
    ...state,
    ask,
    loading: false,
  })),
  on(AskActions.loadCommunityAskFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);